import { GMedication } from '../store/db';
import { MedicationsEntity } from '../store/types/prescription';
import { ANSWER_SNACKING_QUESTION } from './constants';
import { CodedMedications } from './fetchDrugSearch';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    status: string;
    error?: string;
}

export interface NewMedicine extends GMedication {
    replaced_from?: MedicationsEntity;
    suggestions?: CodedMedications[];
}

export default (request: NewMedicine | NewMedicine[]): Promise<Response> => {
    return fetchWithRefresh(ANSWER_SNACKING_QUESTION, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
